module.exports = __webpack_public_path__ + "static/media/export-icon.56ba3659.svg";